(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.MobileSearch = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Search = function (_React$Component) {
    _inherits(Search, _React$Component);

    function Search() {
      _classCallCheck(this, Search);

      return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
    }

    _createClass(Search, [{
      key: 'render',
      value: function render() {
        if (!this.props.hasSearch) {
          return _react2.default.createElement('div', null);
        }

        var searchBoxStyles = {
          position: 'relative',
          height: this.props.searchOpen ? '73px' : '0',
          overflow: 'hidden',
          width: 'calc(100% + 30px)',
          marginLeft: '-15px',
          backgroundColor: '#000',
          transition: 'all 0.3s ease-in-out',
          display: this.props.open && this.props.isMobile ? 'none' : 'block'
        };
        var inputStyles = {
          margin: '0',
          width: '100%',
          padding: '11px 6px 6px',
          textDecoration: 'none',
          fontSize: '20px',
          lineHeight: '19px',
          fontWeight: 300,
          color: '#fff',
          outline: 'none',
          backgroundColor: 'transparent',
          border: '1px solid #707070',
          boxShadow: 'none',
          borderRadius: '3px'
        };

        return _react2.default.createElement(
          'div',
          {
            className: 'mobile-menu-search-box hidden-lg',
            style: searchBoxStyles
          },
          _react2.default.createElement(
            'div',
            {
              className: 'container'
            },
            _react2.default.createElement(
              'div',
              {
                className: 'col-sm-12',
                style: {
                  padding: 0
                }
              },
              _react2.default.createElement(
                'form',
                {
                  id: 'mobile-menu-search-form',
                  action: '/search',
                  style: {
                    padding: '15px 0'
                  }
                },
                _react2.default.createElement('input', {
                  id: 'e-search-input',
                  name: 'sqs',
                  size: '30',
                  maxLength: '128',
                  placeholder: this.props.placeholder,
                  style: inputStyles
                })
              )
            )
          )
        );
      }
    }]);

    return Search;
  }(_react2.default.Component);

  exports.default = Search;


  Search.propTypes = {
    placeholder: _propTypes2.default.string,
    hasSearch: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    searchOpen: _propTypes2.default.bool,
    open: _propTypes2.default.bool
  };

  Search.defaultProps = {
    placeholder: 'Search',
    hasSearch: false
  };
});